export const PRISMICTYPE_TO_ELEMENT: Record<string, React.ElementType> = {
  heading1: 'h1',
  heading2: 'h2',
  heading3: 'h3',
  heading4: 'h4',
  heading5: 'h5',
  heading6: 'h6',
  paragraph: 'p',
  preformatted: 'pre',
  strong: 'strong',
  em: 'em',
  'list-item': 'li',
  'o-list-item': 'li',
  'group-list-item': 'ul',
  'group-o-list-item': 'ol',
  list: 'ul',
  oList: 'ol',
  image: 'div',
  embed: 'div',
  hyperlink: 'a',
  label: 'span',
  span: 'span',
  oembed: 'div'
}
